/* eslint-disable */
const ReactRailsUJS = require(`react_ujs`);
const {useContext} = require(`../applications/utils/multiple-contexts-hack`);

ReactRailsUJS.useContext = useContext;

ReactRailsUJS.useContext(
  require.context(`applications/components/HeaderApp`, true),
  require.context(`applications/components/ItemApp`, true)
);
